@if (safeSvg) {
  <div class="badge-svg">
    <div class="badge-heading">Login-QR-Code</div>
    <div class="badge-svg-content" [innerHTML]="safeSvg"></div>
    @if (documentKey) {
      <button
        type="button"
        nz-button
        nzType="default"
        nzSize="small"
        class="print-btn"
        (click)="print()"
      >
        <i nz-icon nzType="printer" nzTheme="outline"></i>
        Drucken
      </button>
    }
  </div>
}
